import  { useState, useEffect } from "react";
import MainCard from "../../component/MainCard/MainCard";
import SkillLinksTable from "./SkillLinksTable";
import * as actions from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import ReferResource from "./ReferResource";
import useLoadingIndicator from "../../component/Loader/Loader";
import { showErrorToastMessage } from "../../component/Toasts/Toasts";
import { useParams } from "react-router-dom";
import hanldeUnauthorizedUser from "../../component/AccessConditions/UnauthorizedUser";

const SkillLinksData = () => {
  const { unAuthorizeUser } = hanldeUnauthorizedUser();
  const { loadingComponent } = useLoadingIndicator();
  const dispatch = useDispatch();
  const [page, setPage] = useState<Number>(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState<any>([]);
  const [pageSize, setPageSize] = useState<any>(10);
  const [totalEntries, setTotalEntries] = useState<any>();
  const role = localStorage.getItem("role");
  const [onclickSearch, setOnclickSearch] = useState(false);
  let { id } = useParams();
  const editChangeStatusDetails = useSelector(
    (state: any) => state.employeeReducer.editSkillLinksReferResourceDetails
  );
  const handlePageChange = (newPage: any) => {
    setPage(newPage);
    setOnclickSearch(true);
  };

  const handleSearch = (value: any) => {
    setSearchValue(value);
    setPage(1);
  };

  const filterChange = (selectedOption: any) => {
    if (selectedOption) {
      if (filterValue.find((obj: any) => obj.value == selectedOption.value)) {
        setFilterValue((prevValue: any) =>
          prevValue.filter((obj: any) => obj.value != selectedOption.value)
        );
      } else {
        setFilterValue((prevValue: any) => [...prevValue, selectedOption]);
      }
    }
  };
  const onSearchClicked = (value: any) => {
    setOnclickSearch(value);
  };
  const condition: boolean =
    (filterValue.length == 0 && searchValue == "") ||
    (filterValue.length > 0 && onclickSearch);
  const filterKey = filterValue.map((ele: any) => ele.value);
  useEffect(() => {
    unAuthorizeUser();
    if (condition) {
      dispatch(
        actions.getReferralListByIdAction(
          id,
          page,
          pageSize,
          filterKey,
          searchValue,
          (res: any) => {
            if (res?.error?.error_description) {
              showErrorToastMessage(res.error.error_description);
            } else if (res.code === 200) {
                setTotalPages(res.meta_data.totalPageCount);
                setTotalEntries(res.meta_data.totalEntries);
                setOnclickSearch(false);
              }
          }
        )
      );
    }
  }, [
    editChangeStatusDetails,
    page,
    searchValue,
    filterValue,
    pageSize,
    condition,
  ]);

  return (
    <>
      {loadingComponent()}
      {role && role.includes("hr") ? (
        <MainCard>
          <SkillLinksTable
            totalPages={totalPages}
            onPage={page}
            handlePageChange={handlePageChange}
            searchValue={searchValue}
            handleSearch={handleSearch}
            filterValue={filterValue}
            filterChange={filterChange}
            pagePerSize={pageSize}
            setPagePerSize={setPageSize}
            totalEntries={totalEntries}
            onSearchClicked={onSearchClicked}
          />{" "}
        </MainCard>
      ) : (
        <ReferResource />
      )}
      <ToastContainer />
    </>
  );
};

export default SkillLinksData;
